var _objectWithoutProperties = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _regeneratorRuntime = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");
var _asyncToGenerator = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/main/index.ts
var index_exports = {};
__export(index_exports, {
  SeatsioDesigner: function SeatsioDesigner() {
    return _SeatsioDesigner;
  },
  SeatsioEventManager: function SeatsioEventManager() {
    return _SeatsioEventManager;
  },
  SeatsioSeatingChart: function SeatsioSeatingChart() {
    return _SeatsioSeatingChart;
  },
  isBooth: function isBooth() {
    return import_seatsio_types.isBooth;
  },
  isGeneralAdmission: function isGeneralAdmission() {
    return import_seatsio_types.isGeneralAdmission;
  },
  isSeat: function isSeat() {
    return import_seatsio_types.isSeat;
  },
  isTable: function isTable() {
    return import_seatsio_types.isTable;
  }
});
module.exports = __toCommonJS(index_exports);

// src/main/Embeddable.tsx
var React = __toESM(require("react"));

// src/main/util.ts
var didPropsChange = function didPropsChange(prevProps, nextProps) {
  if (Object.keys(prevProps).length !== Object.keys(nextProps).length) {
    return true;
  }
  return Object.keys(nextProps).some(function (propName) {
    var prevValue = prevProps[propName];
    var nextValue = nextProps[propName];
    if (prevValue && nextValue) {
      if (typeof prevValue === "function" && typeof nextValue === "function") {
        return prevValue.toString() !== nextValue.toString();
      }
      if (typeof prevValue === "object" && typeof nextValue === "object") {
        return didPropsChange(prevValue, nextValue);
      }
    }
    return prevValue !== nextValue;
  });
};

// src/main/Embeddable.tsx
var _Embeddable = /*#__PURE__*/function (_React$Component) {
  "use strict";

  _inherits(_Embeddable, _React$Component);
  function _Embeddable(props) {
    var _this;
    _classCallCheck(this, _Embeddable);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(_Embeddable).call(this, props));
    _this.container = React.createRef();
    _this.firstRender = true;
    return _this;
  }
  _createClass(_Embeddable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_Embeddable.seatsioBundles[this.getChartUrl()] || this.firstRender) {
        this.createAndRenderChart();
        this.firstRender = false;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.chart) {
        this.chart.config = this.extractConfigFromProps();
        if (didPropsChange(this.props, prevProps)) {
          this.destroyChart();
          this.createAndRenderChart();
        }
      }
    }
  }, {
    key: "getChartUrl",
    value: function getChartUrl() {
      return this.props.chartJsUrl.replace("{region}", this.props.region);
    }
  }, {
    key: "createAndRenderChart",
    value: function () {
      var _createAndRenderChart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var seatsio2, config;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.loadSeatsio();
              case 2:
                seatsio2 = _context.sent;
                config = this.extractConfigFromProps();
                this.chart = this.createChart(seatsio2, config).render();
                if (this.props.onRenderStarted) {
                  this.props.onRenderStarted(this.chart);
                }
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function createAndRenderChart() {
        return _createAndRenderChart.apply(this, arguments);
      }
      return createAndRenderChart;
    }()
  }, {
    key: "extractConfigFromProps",
    value: function extractConfigFromProps() {
      var _this$props = this.props,
        chartJsUrl = _this$props.chartJsUrl,
        divId = _this$props.divId,
        onRenderStarted = _this$props.onRenderStarted,
        region = _this$props.region,
        config = _objectWithoutProperties(_this$props, ["chartJsUrl", "divId", "onRenderStarted", "region"]);
      config.container = this.container.current;
      return config;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyChart();
    }
  }, {
    key: "destroyChart",
    value: function destroyChart() {
      if (this.chart && this.chart.state !== "DESTROYED") {
        this.chart.destroy();
      }
    }
  }, {
    key: "loadSeatsio",
    value: function loadSeatsio() {
      var chartUrl = this.getChartUrl();
      if (!_Embeddable.seatsioBundles[chartUrl]) {
        _Embeddable.seatsioBundles[chartUrl] = new Promise(function (resolve, reject) {
          var script = document.head.appendChild(document.createElement("script"));
          window.seatsio = void 0;
          script.onload = function () {
            resolve(seatsio);
          };
          script.onerror = function () {
            return reject("Could not load ".concat(script.src));
          };
          script.src = chartUrl;
        });
      }
      return _Embeddable.seatsioBundles[chartUrl];
    }
  }, {
    key: "render",
    value: function render() {
      return /* @__PURE__ */React.createElement("div", {
        ref: this.container,
        style: {
          "height": "100%",
          "width": "100%"
        }
      });
    }
  }]);
  return _Embeddable;
}(React.Component);
_Embeddable.seatsioBundles = {};
_Embeddable.defaultProps = {
  chartJsUrl: "https://cdn-{region}.seatsio.net/chart.js"
};
var Embeddable = _Embeddable;

// src/main/SeatsioDesigner.tsx
var _SeatsioDesigner = /*#__PURE__*/function (_Embeddable2) {
  "use strict";

  _inherits(_SeatsioDesigner, _Embeddable2);
  function _SeatsioDesigner() {
    _classCallCheck(this, _SeatsioDesigner);
    return _possibleConstructorReturn(this, _getPrototypeOf(_SeatsioDesigner).apply(this, arguments));
  }
  _createClass(_SeatsioDesigner, [{
    key: "createChart",
    value: function createChart(seatsio2, config) {
      return new seatsio2.SeatingChartDesigner(config);
    }
  }]);
  return _SeatsioDesigner;
}(Embeddable);

// src/main/SeatsioEventManager.tsx
var _SeatsioEventManager = /*#__PURE__*/function (_Embeddable3) {
  "use strict";

  _inherits(_SeatsioEventManager, _Embeddable3);
  function _SeatsioEventManager() {
    _classCallCheck(this, _SeatsioEventManager);
    return _possibleConstructorReturn(this, _getPrototypeOf(_SeatsioEventManager).apply(this, arguments));
  }
  _createClass(_SeatsioEventManager, [{
    key: "createChart",
    value: function createChart(seatsio2, config) {
      return new seatsio2.EventManager(config);
    }
  }]);
  return _SeatsioEventManager;
}(Embeddable);

// src/main/SeatsioSeatingChart.tsx
var _SeatsioSeatingChart = /*#__PURE__*/function (_Embeddable4) {
  "use strict";

  _inherits(_SeatsioSeatingChart, _Embeddable4);
  function _SeatsioSeatingChart() {
    _classCallCheck(this, _SeatsioSeatingChart);
    return _possibleConstructorReturn(this, _getPrototypeOf(_SeatsioSeatingChart).apply(this, arguments));
  }
  _createClass(_SeatsioSeatingChart, [{
    key: "createChart",
    value: function createChart(seatsio2, config) {
      return new seatsio2.SeatingChart(config);
    }
  }]);
  return _SeatsioSeatingChart;
}(Embeddable);

// src/main/index.ts
var import_seatsio_types = require("@seatsio/seatsio-types");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SeatsioDesigner: _SeatsioDesigner,
  SeatsioEventManager: _SeatsioEventManager,
  SeatsioSeatingChart: _SeatsioSeatingChart,
  isBooth: isBooth,
  isGeneralAdmission: isGeneralAdmission,
  isSeat: isSeat,
  isTable: isTable
});